import { SanitizedText, TextWithInlineLinks } from '@finn-no/tjt-common-components';
import { useEffect } from 'react';
import usePulse from '../../../hooks/usePulse';
import ArrowRightUp from '../../../resources/icons/ArrowRightUp';
import { useSidebarContext } from '../../../state/SidebarContext';
import { SuggestShippingType } from '../../../types/uiTypes';

interface Props {
    hasAskedForFiksFerdig: boolean;
    suggestionMadeText?: SuggestShippingType;
}

const FiksFerdigHelperText = ({ hasAskedForFiksFerdig, suggestionMadeText }: Props) => {
    const { uiText } = useSidebarContext();

    const { trackViewSuggestionMade, trackShowFiksFerdigAllInfo } = usePulse();
    useEffect(() => {
        if (hasAskedForFiksFerdig) {
            trackViewSuggestionMade();
        }
    }, [hasAskedForFiksFerdig]);

    function onTextWithLinksClicked(event: React.MouseEvent<HTMLElement>) {
        const target = event.target as HTMLElement;
        // if target element here is a link - we know that it is the link with more info about shipping, so we can track the event
        if (target.tagName === 'A') {
            trackShowFiksFerdigAllInfo();
        }
    }

    const shippingText = uiText.sections.sidebar.suggestShipping as SuggestShippingType;
    return (
        <>
            {hasAskedForFiksFerdig ? (
                <SanitizedText
                    className="mt-16 text-m mr-4"
                    text={suggestionMadeText?.text ?? shippingText.text}
                />
            ) : (
                <div className="mt-8">
                    <div className="flex items-center mt-8">
                        <div className="mr-12 mt-16" onClick={onTextWithLinksClicked}>
                            <TextWithInlineLinks
                                links={shippingText.textWithLinks.links}
                                text={shippingText.textWithLinks.text}
                            />
                        </div>
                        <div className="mr-6">
                            <ArrowRightUp />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FiksFerdigHelperText;
